<app-spinner [loading]="isLoading() || isCreating"></app-spinner>
<app-ca-full-form
    [profiles]="profiles()"
    [cas]="cas()"
    [cryptotokens]="cryptotokens()"
    (canceled)="onCancel()"
    (created)="onCreate($event)"
    ></app-ca-full-form>
